import React from 'react'
import Uploader from '@liveramp/motif/core/Uploader'

const POST_URL = 'https://httpbin.org/post'

export default function SimpleDemo() {
  return <Uploader id="simple-uploader" url={POST_URL} />
}
